module.exports = __webpack_public_path__ + "img/b.6ff17bb4.png";